<template>
    <div class="page-banner-setting">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">積分管理</div>
            <div class="breadcrumb-item">贈送類型設置</div>
        </div>
        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <!-- <div class="pg-toolbar">
                <div class="pg-btn-wrap">
                    <div class="pg-btn style1" @click="handleToAdd">新增</div>
                </div>
            </div> -->
            <Table size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="img">
                    <div class="table-img-wrap">
                        <img :src="row.url" alt="">
                    </div>
                </template>
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEdit(index)">修改</div>
                        <!-- <div class="pg-btn style1" @click="handleDelete(index)">刪除</div> -->
                    </div>
                </template>
            </Table>
            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">{{totalCount}}</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>
                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>
                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data()
        {
            return {
                pageIndex: 1,
                curPageSize: 10,
                totalCount: 1,
                pageInput: '',
                form: {
                    keywords: ''
                },
                isSubmiting: false,
                table: {
                    column: [
                        {
                            title: '充值渠道',
                            key: 'pid',
                            align: 'center',
                            sortable: true,
                            minWidth: 150
                        },
                        {
                            title: '贈送類型',
                            key: 'type',
                            align: 'center',
                            sortable: true,
                            minWidth: 200
                        },
                        {
                            title: '更新時間',
                            key: 'created_at',
                            align: 'center',
                            sortable: true,
                            minWidth: 200
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            width: 150
                        }
                    ],
                    data: []
                }
            };
        },
        mounted()
        {
            this.getList();
        },
        methods: {
            getList()
            {
                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.creditTypeOption,
                    method: 'get'
                }).then((res) =>
                {
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data;
                        for (let i = 0; i < resData.length; i++)
                        {
                            if(resData[i].pid == 1){
                                resData[i].pid = '線上充值';
                            }
                            else if(resData[i].pid == 2){
                                resData[i].pid = '門店充值';
                            }

                            if(resData[i].type == 1){
                                resData[i].type = '積分';
                            }
                            else if(resData[i].type == 2){
                                resData[i].type = '集金幣';
                            }

                            tempArr.push({
                                id: resData[i].id,
                                pid: resData[i].pid,
                                type: resData[i].type,
                                created_at: resData[i].created_at,
                            });
                        }
                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    }
                }).catch((err) =>
                {
                   this.isSubmiting = false;
                });
            },
            handleToAdd()
            {
                this.$router.push({path: '/creditTypeSettingEdit'});
            },

            handleEdit(index)
            {
                let tableData = this.table.data;
                this.$router.push({path: '/creditTypeSettingEdit?id=' + tableData[index].id});
            },
            handleDelete(index)
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定刪除嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () =>
                    {
                        let tableData = this.table.data;
                        this.isSubmiting = true;

                        this.$Rq.requestAuth({
                            url: this.$Api.creditDelete + '/' + tableData[index].id,
                            method: 'delete'
                        }).then((res) =>
                        {
                            this.isSubmiting = false;
                            if (res.code == 0)
                            {
                                this.$Utils.showSuccess(res.msg);
                                this.pageIndex = 1;
                                this.getList();
                            } else
                            {
                                this.$Utils.showTipInfo(res.msg);
                            }
                        }).catch((err) =>
                        {
                            this.isSubmiting = false;
                        });

                    }
                });
            },

            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },

            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'creditTypeSetting.scss';
</style>